import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';

/**
 * Composable for managing Fixed Fee Metabase dashboard visibility and settings
 * Dashboard loading is handled by MetabaseDashboard component
 */
export function useFixedFeeDashboard() {
  const meStore = useMeStore();
  const {
    me,
    features,
    settings
  } = storeToRefs(meStore);

  // Reads directly from store — store handles optimistic updates, no local ref needed
  const insightsVisible = computed(() => settings.value?.fixedFeeInsightsVisible);

  /**
   * Show dashboard if feature flag is enabled, company ID exists, and user hasn't hidden it
   * Treat undefined as true (default visible until settings load)
   */
  const showMetabaseDashboard = computed(() => {
    const featureFlagEnabled = features.value?.feesMetabaseIntegration;
    const companyId = me.value?.company?.id || '';
    return featureFlagEnabled && !!companyId && insightsVisible.value !== false;
  });

  /**
   * Toggle insights visibility and persist to backend
   * Accepts optional boolean to set explicitly, or toggles current state
   */
  const toggleInsightsVisibility = async visible => {
    const newValue = typeof visible === 'boolean' ? visible : !insightsVisible.value;
    await meStore.updateFixedFeeInsightsVisibility(newValue);
  };
  return {
    selectedDashboardId: 'fixedfee',
    insightsVisible,
    showMetabaseDashboard,
    toggleInsightsVisibility
  };
}